export default __webpack_public_path__ + "static/media/3007.d30c98f6.jpg";